<accredible-two-columns-layout
  *transloco="let t; read: 'login'"
  backgroundImage="'/assets/images/two-columns-layout-component/layout-purple.png'">
  <div leftColumn>
    <acs-cta-panel />
  </div>
  <div rightColumn>
    <accredible-navigation-back
      [text]="t('navigation.back')"
      [textColor]="'var(--color-primary-100)'" />

    <accredible-top-border-card>
      <div class="header">
        <img src="/assets/images/accredible-new-logo.svg" alt="" />

        <div class="tab">
          <div
            data-cy="sign-in"
            [class.selected]="!showRetrieveCredentials()"
            [innerHTML]="t('tabs.sign-in')"
            (click)="selectTab('sign-in')"></div>
          <div
            data-cy="retrieve-credential-link"
            [class.selected]="showRetrieveCredentials()"
            [innerHTML]="t('tabs.retrieve-credentials')"
            (click)="selectTab('retrieve-credentials')"></div>
        </div>
      </div>

      @if (showRetrieveCredentials()) {
        <div
          class="retrieve-credentials-title"
          [innerHTML]="t('retrieve-credentials-form.title')"></div>
        @if (!isEmailSent()) {
          <form
            class="main-panel-form"
            autocomplete="on"
            [formGroup]="formGroup"
            (ngSubmit)="retrieveCredentials()">
            <div class="row-xs form-row">
              <accredible-text-input
                type="email"
                dataCy="email"
                [formControlRef]="getFormControl(formGroup, 'email')"
                [label]="t('retrieve-credentials-form.email.label')"
                [autoComplete]="'email'">
                @if (getFormControl(formGroup, 'email').hasError('required')) {
                  <span [innerHTML]="t('retrieve-credentials-form.email.errors.required')"></span>
                }
                @if (getFormControl(formGroup, 'email').hasError('email')) {
                  <span [innerHTML]="t('retrieve-credentials-form.email.errors.invalid')"></span>
                }
              </accredible-text-input>
            </div>

            <accredible-button-loading
              btnType="submit"
              dataCy="retrieve_my_credentials"
              [isLoading]="isLoading()"
              [size]="'large'"
              [btnText]="t('retrieve-credentials-form.retrieve_my_credentials')">
            </accredible-button-loading>
          </form>
        } @else {
          <acs-email-sent
            [title]="t('retrieve-credentials-form.email_sent.title')"
            [subtitle]="t('retrieve-credentials-form.email_sent.subtitle')" />
        }
      } @else {
        <form
          class="main-panel-form"
          autocomplete="on"
          [formGroup]="formGroup"
          (ngSubmit)="login()">
          <div class="row-xs form-row">
            <accredible-text-input
              type="email"
              dataCy="email"
              [formControlRef]="getFormControl(formGroup, 'email')"
              [label]="t('sign-in-form.email.label')"
              [autoComplete]="'email'">
              @if (getFormControl(formGroup, 'email').hasError('required')) {
                <span [innerHTML]="t('sign-in-form.email.errors.required')"></span>
              }
              @if (getFormControl(formGroup, 'email').hasError('email')) {
                <span [innerHTML]="t('sign-in-form.email.errors.invalid')"></span>
              }
            </accredible-text-input>
          </div>

          <div class="password-input-container row-xs form-row">
            <a
              class="btn-forgot-password"
              routerLink="/forgot-password"
              queryParamsHandling="preserve">
              {{ t('sign-in-form.forgot_password') }}
            </a>

            <accredible-text-input
              type="password"
              dataCy="password"
              [formControlRef]="getFormControl(formGroup, 'password')"
              [label]="t('sign-in-form.password.label')"
              [autoComplete]="'current-password'">
              @if (getFormControl(formGroup, 'password').hasError('required')) {
                <span [innerHTML]="t('sign-in-form.password.errors.required')"></span>
              }
              @if (formGroup.get('password').hasError('invalidRequest')) {
                <span [innerHTML]="t('sign-in-form.password.errors.invalid_request')"></span>
              }
              @if (formGroup.get('password').hasError('invalidThirdRequest')) {
                <span [innerHTML]="t('sign-in-form.password.errors.invalid_third_request')"></span>
              }
              @if (formGroup.get('password').hasError('invalidFourthRequest')) {
                <span [innerHTML]="t('sign-in-form.password.errors.invalid_fourth_request')"></span>
              }
            </accredible-text-input>
          </div>

          <accredible-button-loading
            btnType="submit"
            dataCy="sign-in-button"
            [isLoading]="isLoading()"
            [size]="'large'"
            [btnText]="t('sign-in-form.sign_in')">
          </accredible-button-loading>
        </form>
      }

      <div class="footer">
        <accredible-divider />
        <div class="sign-up-cta">
          {{ t('footer.title') }}
          <a [routerLink]="'/sign-up'">
            {{ t('footer.sign_up') }}
          </a>
        </div>

        <accredible-divider />

        <acs-mini-footer></acs-mini-footer>
      </div>
    </accredible-top-border-card>
  </div>
</accredible-two-columns-layout>
